import { render, staticRenderFns } from "./OrderShareDetail.vue?vue&type=template&id=dfc9fbd2&"
import script from "./OrderShareDetail.vue?vue&type=script&lang=js&"
export * from "./OrderShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderShareDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports